import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';

import Link from '../../AppLink';
import GiftIcon from '../../../icons/gift.svg';

// Router
import { getRoute } from '../../../entry/routes';

import styles from './RewardItem.styl';

const cx = classNames.bind(styles);

export default function RewardItem(props) {
  const { message, applied, goods, code, idx, allConditionsChecked, reward, isOutOfStock } = props;

  const hasGoods = goods.length > 0;
  const isGood = reward === 'good' || reward === 'discount_from_min_size_pizza';
  const Component = isGood && allConditionsChecked && !applied && !isOutOfStock ? Link : 'div';
  const to = hasGoods ? getRoute('stockGifts', idx, code) : getRoute('home');

  return (
    <Component
      className={cx('RewardItem', {
        RewardItem_applied: applied && !isOutOfStock,
        RewardItem_avaivable: allConditionsChecked && !applied && !isOutOfStock,
        RewardItem_outOfStock: isOutOfStock,
      })}
      to={to}
    >
      <div className={cx('RewardItem__content', { RewardItem__content_outOfStock: isOutOfStock })}>
        <div className={cx('RewardItem__message')}>
          <GiftIcon className={cx('RewardItem__icon')} />
          {message}
        </div>
        {(goods.length > 1 || goods[0]?.variations?.length > 1) && applied && !isOutOfStock && (
          <Link to={`${to}?replace`} className={cx('RewardItem__replace')}>
            <FormattedMessage id="promocode.reward.replace" />
          </Link>
        )}
      </div>
    </Component>
  );
}

RewardItem.defaultProps = {
  allConditionsChecked: false,
  goods: [],
  isOutOfStock: false,
};

RewardItem.propTypes = {
  message: PropTypes.string.isRequired,
  reward: PropTypes.string.isRequired,
  applied: PropTypes.bool.isRequired,
  allConditionsChecked: PropTypes.bool,
  goods: PropTypes.array,
  code: PropTypes.string.isRequired,
  idx: PropTypes.number.isRequired,
  isOutOfStock: PropTypes.bool,
};
